<template>
  <div>
    <v-container fluid style="max-width: 1300px">
      <v-form ref="appForm" v-model="formValid">
        <v-row>
          <v-col cols="12" md="8">
            <v-card class="cshadow">
              <div class="cardHeader">Personal Details</div>

              <v-row class="ma-0">
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="appData.fName"
                    hide-details
                    outlined
                    dense
                    label="First Name *"
                    :rules="[rules.req]"
                    @keypress="filterChar(event)"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="appData.lName"
                    hide-details
                    outlined
                    dense
                    label="Last Name"
                    @keypress="filterChar(event)"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-col cols="4" class="pa-0">
                      <v-select
                        v-model="appData.ext"
                        hide-details
                        outlined
                        dense
                        label="Code *"
                        :items="countryCode"
                        item-text="code"
                        item-value="dial_code"
                        :rules="[rules.req]"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="8" class="pa-0">
                      <v-text-field
                        v-model="appData.mobile"
                        hide-details
                        outlined
                        dense
                        label="Mobile *"
                        maxlength="10"
                        counter
                        :rules="[rules.req, rules.mobile]"
                        @keypress="filterNum(event)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="appData.gender"
                    hide-details
                    outlined
                    dense
                    label="Gender *"
                    :items="['Male', 'Female', 'Others']"
                    :rules="[rules.req]"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-card>

            <v-card class="cshadow mt-3">
              <div class="cardHeader">Identification</div>
              <v-row class="ma-0">
                <v-col cols="12" md="6">
                  <v-select
                    v-model="appData.nationality"
                    hide-details
                    outlined
                    dense
                    label="Nationality *"
                    :items="nationality"
                    :rules="[rules.req]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="12" md="6">
                  <v-select
                    v-model="appData.idProofType"
                    hide-details
                    outlined
                    dense
                    label="ID Proof Type *"
                    :items="[
                      'Aadhaar Card',
                      'Driving Licence',
                      'Passport',
                      'Voter ID Card',
                    ]"
                    :rules="[rules.req]"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="appData.idProofNumber"
                    hide-details
                    outlined
                    dense
                    label="ID Proof Number *"
                    :rules="[rules.req]"
                    @keypress="filterCharNum(event)"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="cshadow mt-3">
              <div class="cardHeader">Accreditation Details</div>
              <v-row class="ma-0">
                <v-col cols="12" md="6">
                  <v-select
                    v-model="SelCompany"
                    :items="CompanyType"
                    item-text="companytype_name"
                    item-value="companytype_id"
                    label="Select Company Type *"
                    hide-details
                    @change="OnCompanyTypeClick"
                    outlined
                    dense
                    :rules="[rules.req]"
                    return-object
                  ></v-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select
                    v-model="SelJob"
                    :items="JobName"
                    item-text="jobtype_name"
                    item-value="jobtype_id"
                    label="Select Job *"
                    hide-details
                    outlined
                    dense
                    :disabled="LoadingJob"
                    :loading="LoadingJob"
                    :rules="[rules.req]"
                    return-object
                  ></v-select>
                </v-col>
                
                <!-- <v-col cols="12" md="12">
                  <v-autocomplete
                    v-model="appData.zone"
                    outlined
                    :items="Stand"
                    item-text="stand_name"
                    item-value="stand_id"
                    label="Select Stand/Zone *"
                    hint="Maximum 1 Zone is Allowed"
                    hide-details
                    attach
                    chips
                    small-chips
                    deletable-chips
                    multiple
                    :rules="[rules.reqArr]"
                    @change="changeStand"
                    :counter="maxSelected"
                    :menu-props="menuProps"
                  ></v-autocomplete>
                </v-col> -->
              </v-row>
            </v-card>
            <v-card class="cshadow mt-3">
              <div class="cardHeader">Validity</div>
              <v-row class="ma-0">
                <v-col cols="12" md="6">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="appData.mName"
                        outlined
                        dense
                        hide-details
                        label="Valid From *"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="[rules.req]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker"
                      v-model="appData.mName"
                      :min="from_min"
                      max="2024-06-27"
                      @change="savedob"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="appData.fatherName"
                        outlined
                        dense
                        hide-details
                        label="Valid Till *"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="[rules.req]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker1"
                      v-model="appData.fatherName"
                      :min="appData.mName"
                      max="2024-06-28"
                      @change="savedob1"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card>
            <v-card class="cshadow mt-3">
              <div class="cardHeader">Photo - ID Proof</div>
              <v-row>
                <v-col cols="12" md="6">
                  <div class="text-center">Front Photo</div>
                  <div
                    style="
                      width: 100%;
                      min-height: 180px;
                      text-align: center;
                      padding-top: 15px;
                    "
                  >
                    <img
                      class="previewId"
                      v-if="$store.state.imgId != ''"
                      :src="$store.state.imgId"
                    />
                    <v-icon v-else style="font-size: 11rem" color="#ececec"
                      >mdi-card-account-details-outline</v-icon
                    >
                  </div>
                  <v-card-actions style="background-color: aliceblue">
                    <v-spacer></v-spacer>
                    <IdCard></IdCard>
                  </v-card-actions>
                </v-col>

                <v-col cols="12" md="6" style="border-left: 1px solid #ccc">
                  <div class="text-center">Back Photo</div>
                  <div
                    style="
                      width: 100%;
                      min-height: 180px;
                      text-align: center;
                      padding-top: 15px;
                    "
                  >
                    <img
                      class="previewId"
                      v-if="$store.state.imgIdBack != ''"
                      :src="$store.state.imgIdBack"
                    />
                    <v-icon v-else style="font-size: 11rem" color="#ececec"
                      >mdi-card-bulleted-outline</v-icon
                    >
                  </div>
                  <v-card-actions style="background-color: aliceblue">
                    <v-spacer></v-spacer>
                    <IdCardBack></IdCardBack>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card class="cshadow">
              <div class="cardHeader">Photo - Headshot *</div>
              <div
                style="
                  width: 100%;
                  height: 180px;
                  text-align: center;
                  padding-top: 15px;
                "
              >
                <img
                  class="preview"
                  v-if="$store.state.imgHeadShot != ''"
                  :src="$store.state.imgHeadShot"
                />
                <v-icon v-else style="font-size: 11rem" color="#ececec"
                  >mdi-account-box-outline</v-icon
                >
              </div>
              <Headshot></Headshot>
            </v-card>
            <v-card
              class="cshadow mt-3 pb-2"
              style="background-color: #fff; position: sticky; top: 5px"
            >
              <div class="cardHeader">Preview</div>
              <v-card flat class="mt-2 pt-3 pb-2 mb-2 previewCard">
                <div
                  style="
                    width: 50px;
                    height: 10px;
                    background-color: #efefef;
                    color: #efefef;
                    margin: auto;
                    margin-bottom: 10px;
                  "
                ></div>
                <div class="text-center">
                  <img
                    style="width: 130px; border-radius: 7px"
                    alt=""
                    :src="logoPath"
                  />

                  <v-card
                    flat
                    width="110px"
                    style="
                      width: 110px;
                      margin: auto;
                      margin-top: 100px;
                      height: 120px;
                      border-radius: 2px;
                    "
                  >
                    <img
                      style="width: 110px; border-radius: 2px"
                      alt=""
                      v-if="$store.state.imgHeadShot != ''"
                      :src="$store.state.imgHeadShot"
                    />
                  </v-card>
                </div>
                <div
                  style="
                    background-color: #fff;
                    border-radius: 0px !important;
                    text-transform: uppercase;
                    line-height: 1.1rem;
                    padding: 8px 0px;
                    font-weight: 600;
                  "
                >
                  <div class="text-center">
                    {{ appData.fName }} {{ appData.lName }}
                  </div>
                  <div class="text-center" v-if="SelCompany.companytype_name">
                    {{ SelCompany.companytype_name }}
                  </div>
                  
                </div>
              </v-card>
            </v-card>
          </v-col>
        </v-row>
        <v-card class="cshadow mt-3 pa-2">
          <v-card-actions>
            <v-btn
              class="pl-4 pr-4"
              x-large
              color="info"
              @click="saveApplication(1)"
              ><v-icon left>mdi-content-save</v-icon> SAVE AS DRAFT</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              class="pl-4 pr-4"
              x-large
              color="success"
              :disabled="!formValid"
              @click="saveApplication(2)"
              ><v-icon left>mdi-content-save-move</v-icon> SUBMIT</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-container>
    <v-overlay :value="isLoading" style="z-index: 9999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar.display" top :color="snackbar.color">
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import Headshot from "../application/HeadShot";
import IdCard from "../application/IdCard";
import IdCardBack from "../application/IdCardBack";
import country from "../../data/country.json";
import nationality from "../../data/nationality.json";
import countryCode from "../../data/countryCode.json";
export default {
  components: { Headshot, IdCard, IdCardBack },
  data: () => ({
    logoPath: "",
    isLoading: false,
    snackbar: { display: false, text: "", color: "primary" },
    headShotMode: "",
    standPreviewText: "",
    formValid: false,
    menu2: false,
    menu1: false,
    CompanyType: [],
    JobName: [],
    SelCompany: "",
    SelJob: "",
    LoadingJob: false,
    Stand: [],
    SelStand: "",
    SelMedCond: [],
    dob_max: "",
    from_min: "",
    modPdf: false,
    rules: {
      req: (val) => (val !== null && val !== "") || "Required!",
      reqArr: (val) => (val !== null && val !== []) || "Required!",
      pin: (val) => val.length === 6 || "Invalid PIN Code!",
      mobile: (val) => val.length === 10 || "Invalid Mobile No!",
      email: (v) =>
        /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "E-mail must be valid",
    },
    capKey: "6LddAvIcAAAAAFtPO39lfaDlm2Dvb3m4HwI2dOcp",
    appData: {
      event_id: "",
      venue_id: "",
      vendor_id: "",
      companytype_id: "",
      jobtype_id: "",
      other_jobtype: "",
      title: "",
      fName: "",
      mName: "",
      lName: "",
      fatherName: "",
      gender: "",
      dob: "",
      email: "",
      ext: "+91",
      mobile: "",
      addLine1: "",
      addLine2: "",
      city: "",
      country: "India",
      state: "",
      pinCode: "",
      nationality: "Indian",
      idProofType: "",
      idProofNumber: "",
      designations: "",
      picHeadShot: "",
      picIdFront: "",
      picIdBack: "",
      saveStatus: "",
      status_id: 0,
      created_by: "1",
      zone: [],
      anyMedicalCondition: "",
      medicalCondition: "",
      isVaccinated: "",
      vaccineTaken: "",
      vaccineCountry: "",
      firstDose: "",
      secondDose: "",
      covid_certificate: "",
      capResponse: "",
      passportExpiryDate: "",
      preferedCity:0
    },
    countries: [],
    countryCode: [],
    nationality: [],
    preferedCityList: [],
    certificate_visible: false,
    vacCertificate: "",
    maxSelected: 1,
    menuProps: {
      disabled: false,
    },
  }),
  async mounted() {
    this.loading = true;

    if (this.$store.state.appInfo.AppMode == "New") {
      const cc = await this.$axios.get("Application/balance");

      const fc = await cc.data.result[0].BAL;

      if (fc <= 0) {
        this.showSnackbar("error", "Application Limit Exceeded!");
        this.$router.push("/app/dashboard").catch({});
        return;
      }
      this.loading = false;
    }
    this.countries = country;
    this.nationality = nationality;
    this.countryCode = countryCode;
    if (this.$store.state.Deadline != "open") {
      this.$router.push("/app/dashboard").catch({});
      return;
    }

    this.$store.commit("setPageTitle", "New Application");
    this.$store.commit("setHeadshot", false);
    this.$store.commit("setIdOpen", false);
    this.$store.commit("setIdBackOpen", false);
    this.logoPath =
      this.$apiPhotoPath +
      "/assets/" +
      this.$store.state.eventInfo.EventUrl +
      "/logo.jpg";
    this.bindcompanytype(this.$store.state.eventInfo.VendorId);
    this.bindStand(
      this.$store.state.eventInfo.EventId,
      this.$store.state.eventInfo.VenueId
    );
    this.bindPreferedCity(this.$store.state.eventInfo.EventId);
    let d = new Date();
    d.setDate(d.getDate() - 6570);
    this.dob_max = d.toISOString().substr(0, 10);

    let dm = new Date();
    this.from_min = dm.toISOString().substr(0, 10);

    if (this.$store.state.appInfo.AppMode == "Edit") {
      this.binddata(this.$store.state.appInfo.AppId);
    }
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    "$store.state.appInfo.AppMode": function () {
      if (this.$store.state.appInfo.AppMode == "New") {
        this.$refs.appForm.reset();
        //this.clearForm();
      }
    },
    "appData.isVaccinated": function () {
      if (
        this.appData.isVaccinated == "First Dosage" ||
        this.appData.isVaccinated == "Fully Vaccinated"
      ) {
        this.certificate_visible = true;
      } else {
        this.certificate_visible = false;
      }
    },
  },
  methods: {
    filterNum: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^\d+$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    filterChar: function (evt) {
      evt = evt ? evt : window.event;
      if (
        (evt.charCode > 64 && evt.charCode < 91) ||
        (evt.charCode > 96 && evt.charCode < 123) ||
        evt.charCode == 32
      ) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    filterCharNum: function (evt) {
      evt = evt ? evt : window.event;
      if (
        (evt.charCode > 47 && evt.charCode < 58) ||
        (evt.charCode > 64 && evt.charCode < 91) ||
        (evt.charCode > 96 && evt.charCode < 123)
      ) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    clearApplication() {
      this.$store.commit("resetApplication");
      this.$refs.appForm.reset();
      //this.clearForm();
    },
    savedob(date) {
      this.$refs.menu2.save(date);
    },
    savedob1(date) {
      this.$refs.menu1.save(date);
    },
    showSnackbar: function (scolor, stext) {
      this.snackbar.display = true;
      this.snackbar.text = stext;
      this.snackbar.color = scolor;
    },
    binddata: async function (AppID) {
      this.isLoading = true;
      await this.$axios
        .post("Application/details", { application_id: AppID })
        .then((res) => {
          this.appData = res.data.result;

          //console.log(this.appData);

          this.SelCompany = {
            companytype_id: this.appData.companytype_id,
            companytype_name: this.appData.companytype_id,
          };

          this.bindjobtype(this.appData);

          this.SelJob = {
            jobtype_id: this.appData.jobtype_id,
            jobtype_name: this.appData.jobtype_name,
          };

          this.changeStand(this.appData.zone);

          if (
            this.appData.medicalCondition != null &&
            this.appData.medicalCondition != ""
          ) {
            this.SelMedCond = this.appData.medicalCondition.split(",");
          }

          if (
            res.data.result.picHeadShot == "" ||
            res.data.result.picHeadShot == null
          ) {
            this.$store.commit("setHeadshotImg", "");
          } else {
            this.$store.commit(
              "setHeadshotImg",
              this.$apiPhotoPath + "/" + res.data.result.picHeadShot
            );
          }

          if (
            res.data.result.picIdFront == "" ||
            res.data.result.picIdFront == null
          ) {
            this.$store.commit("setIdImg", "");
          } else {
            this.$store.commit(
              "setIdImg",
              this.$apiPhotoPath + "/" + res.data.result.picIdFront
            );
          }

          if (
            res.data.result.picIdBack == "" ||
            res.data.result.picIdBack == null
          ) {
            this.$store.commit("setIdBackImg", "");
          } else {
            this.$store.commit(
              "setIdBackImg",
              this.$apiPhotoPath + "/" + res.data.result.picIdBack
            );
          }
          this.appData.capResponse = "";
          //this.SelCompany = res.data.result.aczone;
          this.isLoading = false;
        });
    },

    bindcompanytype: async function (companyID) {
      await this.$axios
        .get("CompanyType/GetByVendorId/" + companyID)
        .then((res) => {
          this.CompanyType = res.data.result;
          // if (this.CompanyType.length == 1) {
          //   this.appData.companytype_id = this.CompanyType[0];
          //   this.bindjobtype(this.SelCompany.companytype_id);
          // }
        });
    },

    bindPreferedCity: async function (EventID) {
      await this.$axios.get("media/mediavenue/" + EventID).then((res) => {
        this.preferedCityList = res.data.result;
      });
    },

    OnCompanyTypeClick(value) {
      this.bindjobtype(value);
    },

    bindjobtype: async function (companyID) {
      this.LoadingJob = true;
      await this.$axios
        .get(
          "JobType/GetByEventIDCompanyType/" +
            this.$store.state.eventInfo.EventId +
            "/" +
            companyID.companytype_id
        )
        .then((res) => {
          this.JobName = res.data.result;
          this.LoadingJob = false;
        });
    },

    bindStand: async function (EventID, VenueID) {
      await this.$axios
        .get("Stand/GetStandByEidVid/" + EventID + "/" + VenueID)
        .then((res) => {
          this.Stand = res.data.result;
        });
    },
    changeStand: function (val) {
      if (val.length >= this.maxSelected) {
        this.menuProps.disabled = true;
        this.showSnackbar("error", "Only 1 Stand is Allowed!");
      } else {
        this.menuProps.disabled = false;
      }

      var filteredArray = this.Stand.filter(function (itm) {
        return val.indexOf(itm.stand_id) > -1;
      });
      let st = "";
      filteredArray.forEach((el) => {
        st = st + el.print_text + ",";
      });
      this.standPreviewText = st.slice(0, st.length - 1);
    },

    saveApplication: async function (sMode) {
      this.appData.capResponse = "";
      if (this.$store.state.imgHeadShot.split(",").length > 1) {
        this.appData.picHeadShot = this.$store.state.imgHeadShot.split(",")[1];
      } else {
        this.appData.picHeadShot = "";
      }
      if (this.$store.state.imgId.split(",").length > 1) {
        this.appData.picIdFront = this.$store.state.imgId.split(",")[1];
      } else {
        this.appData.picIdFront = "";
      }
      if (this.$store.state.imgIdBack.split(",").length > 1) {
        this.appData.picIdBack = this.$store.state.imgIdBack.split(",")[1];
      } else {
        this.appData.picIdBack = "";
      }

      this.appData.event_id = this.$store.state.eventInfo.EventId;
      this.appData.venue_id = this.$store.state.eventInfo.VenueId;
      this.appData.vendor_id = this.$store.state.eventInfo.VendorId;
      this.appData.saveStatus = this.$store.state.eventInfo.LinkId || '';

      if (this.appData.preferedCity == 0) {
        this.appData.preferedCity = this.$store.state.eventInfo.VenueId;
      }

      if (this.SelCompany == "" || this.SelCompany == undefined) {
        this.appData.companytype_id = 0;
      } else {
        this.appData.companytype_id = this.SelCompany.companytype_id;
      }

      if (this.SelJob == "" || this.SelJob == undefined) {
        this.appData.jobtype_id = 0;
      } else {
        this.appData.jobtype_id = this.SelJob.jobtype_id;
      }

      this.appData.status_id = sMode;

      //console.log(this.appData);

      if (sMode == 1) {
        if (this.appData.fName == "") {
          this.showSnackbar("error", "Please Enter Name!");
          return;
        }

        this.isLoading = true;

        if (this.$store.state.appInfo.AppMode == "New") {
          await this.$axios
            .post("Application", this.appData)
            .then(async (res) => {
              if (res.data.status == "Success") {
                if (this.vacCertificate != "") {
                  await this.uploadCertificate(res.data.result.AID);
                }
                this.showSnackbar("success", "Application Saved!");

                this.$store.commit("resetApplication");
                this.$refs.appForm.reset();
                //this.clearForm();
                this.$router.push("/app/reports");
              } else if (res.data.status == "Failed") {
                if (res.data.message == "LIMITEXCEEDED") {
                  this.showSnackbar("error", "Application Limit Exceeded!");
                } else {
                  this.showSnackbar("error", "Something went wrong!");
                }
              }
              this.isLoading = false;
            });
        } else {
          await this.$axios
            .put("Application/" + this.$store.state.appInfo.AppId, this.appData)
            .then(async (res) => {
              if (res.data.status == "Success") {
                if (this.vacCertificate != "") {
                  await this.uploadCertificate(res.data.result.AID);
                }
                this.showSnackbar("success", "Application Saved!");

                this.$store.commit("resetApplication");
                this.$refs.appForm.reset();
                this.clearForm();
                this.$router.push("/app/reports");
              }
              this.isLoading = false;
            });
        }
      } else {
        this.$refs.appForm.validate();

        if (this.formValid) {
          if (this.appData.companytype_id == "") {
            this.showSnackbar("error", "Please Select Job Type!");
            return;
          }
          if (this.appData.jobtype_id == 0) {
            this.showSnackbar("error", "Please Select Zone!");
            return;
          }
          // if (this.appData.zone.length == 0) {
          //   this.showSnackbar("error", "Please Select Zone!");
          //   return;
          // }

          if (this.$store.state.imgHeadShot == "") {
            this.showSnackbar("error", "Please Upload Headshot Image!");
            return;
          }
          if (this.$store.state.imgId == "") {
            this.showSnackbar("error", "Please Upload Id Proof Image!");
            return;
          }

          let isCovidCerReady = false;
          if (
            this.appData.covid_certificate == null ||
            this.appData.covid_certificate == ""
          ) {
            if (this.vacCertificate == "") {
              this.appData.covid_certificate = "";
              // this.showSnackbar(
              //   "error",
              //   "Please upload a Covid-19 Vaccination Certificate."
              // );
              // return;
            } else {
              isCovidCerReady = true;
            }
          }

          this.isLoading = true;

          if (this.$store.state.appInfo.AppMode == "New") {
            await this.$axios
              .post("Application", this.appData)
              .then(async (res) => {
                if (res.data.status == "Success") {
                  if (isCovidCerReady == true) {
                    await this.uploadCertificate(res.data.result.AID);
                  }
                  this.showSnackbar("success", "Application Submitted!");
                  this.$store.commit("resetApplication");
                  this.$refs.appForm.reset();
                  this.clearForm();
                  this.$router.push("/app/reports");
                } else if (res.data.status == "Failed") {
                  if (res.data.message == "LIMITEXCEEDED") {
                    this.showSnackbar("error", "Application Limit Exceeded!");
                  } else {
                    this.showSnackbar("error", "Something went wrong!");
                  }
                }
                this.isLoading = false;
              });
          } else {
            await this.$axios
              .put(
                "Application/" + this.$store.state.appInfo.AppId,
                this.appData
              )
              .then(async (res) => {
                if (res.data.status == "Success") {
                  if (isCovidCerReady == true) {
                    await this.uploadCertificate(
                      this.$store.state.appInfo.AppId
                    );
                  }
                  this.showSnackbar("success", "Application Submitted!");

                  this.$store.commit("resetApplication");
                  this.$refs.appForm.reset();
                  this.clearForm();
                  this.$router.push("/app/reports");
                }
                this.isLoading = false;
              });
          }
        }
      }
    },
    selectFileCertificate(file) {
      if (file != undefined) {
        if (file.size > 1024 * 1024) {
          this.$refs.fileCertificateUpload.value = null;
          this.$refs.fileCertificateUpload.reset();
          alert("File too big (> 1MB)");
          return;
        }
        this.vacCertificate = file;
      } else {
        this.vacCertificate = "";
      }
    },

    async uploadCertificate(aId) {
      const fName = this.appData.fName;
      const vId = this.$store.state.eventInfo.VendorId;
      let formData = new FormData();
      formData.append("file", this.vacCertificate);
      await this.$axios
        .post(
          "application/uploadCertificate/" + aId + "/" + fName + "/" + vId,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          return res.data.status;
        });
    },

    clearForm: function () {
      this.appData.title = "";
      this.appData.fName = "";
      this.appData.mName = "";
      this.appData.lName = "";
      this.appData.fatherName = "";
      this.appData.gender = "";
      this.appData.dob = "";
      this.appData.email = "";
      this.appData.mobile = "";
      this.appData.addLine1 = "";
      this.appData.addLine2 = "";
      this.appData.city = "";
      this.appData.country = "";
      this.appData.state = "";
      this.appData.pinCode = "";
      this.appData.nationality = "";
      this.appData.idProofType = "";
      this.appData.idProofNumber = "";
      this.appData.designations = "";
      this.appData.picHeadShot = "";
      this.appData.picIdFront = "";
      this.appData.picIdBack = "";
      this.appData.companytype_id = "";
      this.appData.jobtype_id = "";
      this.appData.zone = [];
      this.appData.anyMedicalCondition = "";
      this.appData.medicalCondition = "";
      this.appData.isVaccinated = "";
      this.appData.vaccineTaken = "";
      this.appData.vaccineCountry = "";
      this.appData.firstDose = "";
      this.appData.secondDose = "";
      this.appData.other_jobtype = "";
      this.standPreviewText = "";
    },
  },
};
</script>

<style scoped>
.preview {
  width: 120px;
  border-radius: 7px;
  box-shadow: 0 0 16px #4e4e4e;
  margin: auto;
}
.previewId {
  width: 90%;
  border-radius: 7px;
  box-shadow: 0 0 16px #4e4e4e;
  margin: auto;
}
.previewCard {
  background-color: #ffffff;
  background-image: linear-gradient(
    140deg,
    #5c5c5c 0%,
    #aaaaaa 50%,
    #5c5c5c 85%
  );
  max-width: 290px;
  height: 520px;
  margin: auto;
  border-radius: 15px;
  border-bottom-left-radius: 15px !important;
  border-bottom-right-radius: 15px !important;
}
.cshadow {
  box-shadow: 0 0 15px #e7e7e7 !important;
}
</style>
